module.exports = __webpack_public_path__ + "img/area.dc1fce3c.png";